const trust = [
  { icon: "ri-flashlight-line", text: "每日速递新近事" },
  { icon: "ri-calendar-check-line", text: "每周瓜汇总" },
  { icon: "ri-pie-chart-2-line", text: "本月重点盘点" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-950">
      {/* 背景图 + 遮罩 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20stylized%20editorial%20vector%20artwork%20of%20a%20playful%20trending%20topic%20collage%20with%20melons%20gossip%20bubbles%20movie%20clappers%20and%20spotlights%20floating%20over%20a%20warm%20sunset%20background%2C%20rich%20coral%20orange%20and%20fresh%20melon%20green%20with%20cream%20highlights%2C%20bold%20modern%20minimal%20flat%20style%2C%20no%20text%20no%20letters&width=1600&height=900&seq=gua-hero-00&orientation=landscape"
          alt="最新吃瓜 近期热门事件盘点的风格化背景插画"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/60" />
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pb-24 pt-28 text-center md:px-6 md:pb-32 md:pt-40">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-bold text-white backdrop-blur-sm whitespace-nowrap">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
          </span>
          今日已更新 · 新近合集滚动中
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-black leading-tight text-white md:text-5xl md:leading-tight">
          最新吃瓜
          <span className="mt-3 block text-xl font-bold text-secondary-300 md:mt-4 md:text-3xl">
            近期热门事件一网打尽
          </span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          不用翻遍全网，点开这里就能快速回顾近期最火的瓜和人物——本周瓜汇总、本月盘点、新近合集全收录，补课吃瓜两不误。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#weekly"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-bold text-white transition-colors hover:bg-primary-400 sm:w-auto"
          >
            本周瓜速览
            <i className="ri-arrow-right-line ml-2" aria-hidden="true" />
          </a>
          <a
            href="#subscribe"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-white/15 px-7 py-3 text-sm font-bold text-white backdrop-blur-sm transition-colors hover:bg-white/25 sm:w-auto"
          >
            订阅每周瓜报
          </a>
        </div>

        <dl className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          {trust.map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-xs font-semibold text-white/80">
              <i className={`${item.icon} text-sm text-secondary-300`} aria-hidden="true" />
              <dt className="sr-only">{item.text}</dt>
              <dd>{item.text}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}